import { render, staticRenderFns } from "./SignatureDetails.vue?vue&type=template&id=451c3aee&scoped=true&"
import script from "./SignatureDetails.vue?vue&type=script&lang=js&"
export * from "./SignatureDetails.vue?vue&type=script&lang=js&"
import style0 from "./SignatureDetails.vue?vue&type=style&index=0&id=451c3aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c3aee",
  null
  
)

export default component.exports